import { render, staticRenderFns } from "./AlertInputs.vue?vue&type=template&id=3d370498&"
import script from "./AlertInputs.vue?vue&type=script&lang=js&"
export * from "./AlertInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports